/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Body1Inputs */

const en_csv_to_json_body1 = /** @type {(inputs: Csv_To_Json_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading CSV is harder than it looks, because the format is a family of conventions rather than a single specification. This parser scans the whole document rather than splitting it into lines first, which is what lets a newline inside a quoted field stay part of that field instead of tearing the record in half. Line feed, carriage return, and the pair of them are all accepted as record separators, so files from Windows tools work without conversion.`)
};

const ko_csv_to_json_body1 = /** @type {(inputs: Csv_To_Json_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 읽기는 보이는 것보다 어렵습니다. 이 형식은 하나의 규격이 아니라 관례의 집합이기 때문입니다. 이 파서는 문서를 줄로 먼저 쪼개지 않고 전체를 훑습니다. 그래서 인용 필드 안의 줄바꿈이 레코드를 반으로 찢지 않고 그 필드의 일부로 남습니다. 라인 피드, 캐리지 리턴, 그리고 둘의 쌍이 모두 레코드 구분자로 받아들여지므로 Windows 도구에서 온 파일도 변환 없이 동작합니다.`)
};

const ja_csv_to_json_body1 = /** @type {(inputs: Csv_To_Json_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV を読むのは見た目より難しいです。この形式は 1 つの規格ではなく慣習の集まりだからです。このパーサは文書を先に行へ分割せず全体を走査します。だから引用フィールド内の改行がレコードを半分に裂くことなく、そのフィールドの一部として残ります。ラインフィード、キャリッジリターン、その対のいずれもレコード区切りとして受け入れるので、Windows のツールから来たファイルも変換なしで動きます。`)
};

/**
* | output |
* | --- |
* | "Reading CSV is harder than it looks, because the format is a family of conventions rather than a single specification. This parser scans the whole document r..." |
*
* @param {Csv_To_Json_Body1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_body1 = /** @type {((inputs?: Csv_To_Json_Body1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Body1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_body1(inputs)
	if (locale === "ko") return ko_csv_to_json_body1(inputs)
	return ja_csv_to_json_body1(inputs)
});